import {
	workflowNodeState,
	type WorkflowNodeEntry,
	type WorkflowNodeState,
} from "@/lib/workflow-tasks";

const PULSE = "animate-[izanagi-pulse_1.8s_ease-in-out_infinite]";

// 起きていない・待機中のノードは輪だけ。塗ると「走っている / 終わった」と区別が付かない。
const HOLLOW = "shadow-[inset_0_0_0_1px_var(--fg-3)]";

// アクセントは走っているノードだけに使う。完了はグレー、取り消しは完了と見分けられるよう一段暗いグレー。
const DOT_CLASS: Record<WorkflowNodeState, string> = {
	pending: HOLLOW,
	queued: HOLLOW,
	running: `bg-accent ${PULSE}`,
	cancelRequested: `bg-accent ${PULSE}`,
	completed: "bg-fg-3",
	failed: "bg-danger",
	timedOut: "bg-danger",
	cancelled: "bg-fg-4",
};

function WorkflowNodeDot({ state, title }: { state: WorkflowNodeState; title?: string }) {
	return (
		<span
			data-testid="workflow-node-dot"
			data-state={state}
			title={title}
			className={`h-1.5 w-1.5 shrink-0 rounded-full ${DOT_CLASS[state]}`}
		/>
	);
}

/**
 * ノード 1 つを丸 1 つで描く進捗。件数の文字より先に、どれだけ走っていてどれだけ残っているかが
 * 一目で分かる。並びは呼び出し側 (フェーズ順) に任せる。
 */
export function WorkflowProgressDots({
	nodes,
	className = "",
}: {
	nodes: readonly WorkflowNodeEntry[];
	className?: string;
}) {
	if (nodes.length === 0) return null;
	// button の中にも置けるよう span で描く (フェーズ見出しは丸ごと 1 つのボタン)。
	return (
		<span data-testid="workflow-progress-dots" className={`flex flex-wrap gap-1 ${className}`}>
			{nodes.map((node) => (
				<WorkflowNodeDot key={node.id} state={workflowNodeState(node)} title={node.description} />
			))}
		</span>
	);
}
